<div class="confirmation-dialog-container">
	<div class="d-flex justify-content-between align-items-center">
		<span class="title" mat-dialog-title>{{ data.mode === 'PENDING' ? ('ASSORTED.PENDING' | translate) : ('BUTTON.' + data.mode | translate) }}</span>
		<button mat-icon-button (click)="closeDialog()" class="d-flex justify-content-center align-items-center me-4">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-dialog-content class="m-0 p-4">
		@if(messageVisibility()) {
		<p class="message-text">{{ getMessageText() | translate }}</p>
		}
		@if(data.pillInfo) {
		<span class="info-pill" [ngClass]="data.pillInfo.severity ? 'severity-' + data.pillInfo.severity : ''">
			<mat-icon class="info-pill-icon" fontSet="material-icons-outlined">{{ data.pillInfo.icon || 'info' }}</mat-icon>
			<span class="info-pill-label">{{ data.pillInfo.label | translate }}:</span>
			<span class="info-pill-value">{{ data.pillInfo.value }}</span>
		</span>
		}
    @if(data.type === 'custom-fields') {
      <div class="d-flex flex-wrap">
      @for(field of data.fields; track field) {
        @if (field.type === 'date-range') {
          <mat-form-field class="w-50 pt-2 pe-1">
            <mat-date-range-input [formGroup]="dateRangePicker" color="primary" [rangePicker]="picker">
              <input id="dateFrom" formControlName="dateFrom" matStartDate placeholder="Start date" />
              <input id="dateTo" formControlName="dateTo" matEndDate placeholder="End date" />
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker>
              <mat-date-range-picker-actions>
                <button mat-button matDateRangePickerCancel>{{ 'BUTTON.CANCEL' | translate }}</button>
                <button mat-raised-button color="primary" matDateRangePickerApply>{{ 'BUTTON.APPLY' | translate }}</button>
              </mat-date-range-picker-actions>
            </mat-date-range-picker>

            @if (dateRangePicker.controls['dateFrom'].hasError('matStartDateInvalid')) {
            <mat-error>Invalid start date</mat-error>
            } @if (dateRangePicker.controls['dateTo'].hasError('matEndDateInvalid')) {
            <mat-error>Invalid end date</mat-error>
            }
          </mat-form-field>

        } @else if (field.type === 'date-time') {
          <div class="w-100 pt-2">
          <mat-form-field class="w-50 pe-1">
            <mat-label>{{ field.label | translate }}</mat-label>
            <mtx-datetimepicker #datetimePicker type="datetime">
            </mtx-datetimepicker>
            <input [mtxDatetimepicker]="datetimePicker" [formControl]="getDateTimeControl(field.key)" matInput>
            <mtx-datetimepicker-toggle [for]="datetimePicker" matSuffix></mtx-datetimepicker-toggle>
          </mat-form-field>
          </div>

        } @else if (field.type === 'date') {
          <!-- field.inline puts the picker in a half-width cell so a from/to pair shares one row. -->
          <div [ngClass]="field.inline ? 'w-50 pt-2 pe-1' : 'w-100 pt-2'">
          <mat-form-field [ngClass]="field.inline ? 'w-100' : 'w-50 pe-1'">
            <mat-label>{{ field.label | translate }}</mat-label>
            <input matInput [matDatepicker]="datePicker" [formControl]="getDateTimeControl(field.key)" [max]="field.maxDate" [required]="field.required">
            <mat-datepicker-toggle matIconSuffix [for]="datePicker"></mat-datepicker-toggle>
            <mat-datepicker #datePicker></mat-datepicker>
          </mat-form-field>
          </div>

        } @else if (field.type === 'selection-multiple') {
          <mat-form-field class="w-50 pt-2 pe-1">
            <mat-label>{{ 'ASSORTED.SELECT_OPTION' | translate }}</mat-label>
            <select id="selection" style="display: none"></select>
            <!-- workaround for material-chrome bug -->
            <mat-select id="selection" placeholder="{{ 'ASSORTED.SELECT_OPTION' | translate }}" [formControl]="selectFormControl" multiple>
              @for (data of field.data; track $index) {
              <mat-option [value]="data.value">{{ data.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        } @else if (field.type === 'selection') {
          <!-- field.standalone keeps the select on a row of its own, still left-aligned, so an
               inline date pair below it doesn't flow up alongside. -->
          <div [ngClass]="field.standalone ? 'w-100 pt-2' : 'w-50 pt-2 pe-1'">
            <mat-form-field [ngClass]="field.standalone ? 'w-50 pe-1' : 'w-100'">
              <mat-label>{{ field.label || 'ASSORTED.SELECT_OPTION' | translate }}<span class="required-asterisk"> *</span></mat-label>
              <select id="single-selection" style="display: none"></select>
              <!-- workaround for material-chrome bug -->
              <mat-select id="single-selection" placeholder="{{ field.label || 'ASSORTED.SELECT_OPTION' | translate }}" [formControl]="getFieldControl(field.key)">
                @for (data of getSelectionData(field); track $index) {
                <mat-option [value]="data.value">{{ data.label || data.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        } @else if (field.type === 'checkbox') {
          @if ((!field.hideWhenMergeText || !getFieldControl('mergeText').value) && (!field.hideWhenSRT || getFieldControl('format').value !== 'SRT')) {
          <div class="w-100 pt-2 pe-1">
            <mat-checkbox [formControl]="getFieldControl(field.key)">
              {{ field.label | translate }}
            </mat-checkbox>
          </div>
          }
        } @else if (field.type === 'textfield') {
          @if (isFieldVisible(field)) {
          <mat-form-field class="w-50 pt-2 pe-1">
            <mat-label>{{ field.label | translate }}</mat-label>
            <input [type]="field.key === 'daysBehind' ? 'number' : 'text'" matInput [formControl]="getTextFieldControl(field.key)" [disabled]="isFieldDisabled(field)" />
          </mat-form-field>
          }
        } @else if (field.type === 'file') {
          <div class="w-50 pt-2 pe-1">
            <input type="file" [id]="'file-' + field.key" (change)="onFileSelected($event, field.key)" style="display: none;" accept="audio/*,video/*" [disabled]="isFieldDisabled(field)" />
            <mat-form-field class="w-100">
              <mat-label>{{ field.label | translate }}</mat-label>
              <input matInput readonly [value]="getSelectedFileName(field.key)" (click)="!isFieldDisabled(field) && triggerFileInput(field.key)" [style.cursor]="isFieldDisabled(field) ? 'not-allowed' : 'pointer'" [disabled]="isFieldDisabled(field)" />
              <button mat-icon-button matSuffix (click)="!isFieldDisabled(field) && triggerFileInput(field.key)" type="button" [disabled]="isFieldDisabled(field)">
                <mat-icon>upload_file</mat-icon>
              </button>
            </mat-form-field>
          </div>
        }
        @else if (field.type === 'textarea') {
          <mat-form-field class="w-100 pt-2 pe-1">
            <mat-label>{{ 'ASSORTED.DATA' | translate }}</mat-label>
            <textarea matInput class="w-100 pb-1" [formControl]="textarea" cdkTextareaAutosize cdkAutosizeMinRows="10" cdkAutosizeMaxRows="10"></textarea>
          </mat-form-field>
        }
        @else if (field.type === 'rawHtml') {
          <div class="w-100 pt-2 pe-1" [innerHTML]="htmlContent"></div>
        }
      }
      @if (dateRangeError) {
      <div class="w-100 pt-2">
        <p class="text-danger mb-0">{{ dateRangeError | translate: dateRangeErrorParams }}</p>
      </div>
      }
      @for(field of data.fields; track field) {
        @if (field.type === 'radio') {
          <div class="w-100 pt-3 pb-2">
            <div class="d-flex gap-3">
              @for (option of field.options; let i = $index; track option) {
                <mat-radio-button
                  color="primary"
                  [value]="option"
                  [checked]="getFieldControl(field.key).value === option"
                  (change)="onRadioChange(field.key, option)">
                  {{ field.optionLabels ? field.optionLabels[i] : option }}
                </mat-radio-button>
              }
            </div>
          </div>
        }
      }
    </div>
    }
    @else if (data.type === 'custom-tabs') {
      <mat-tab-group [(selectedIndex)]="activeTabIndex" class="pt-2">
        @for (tab of data.tabs; let tabIndex = $index; track tab.label) {
          <mat-tab [label]="tab.label">
            <div class="d-flex flex-wrap">
              @for (field of tab.fields; track field) {
                @if (isTabFieldVisible(tabIndex, field)) {
                <ng-container [ngSwitch]="field.type">
                  <mat-form-field *ngSwitchCase="'input'" class="w-50 pt-2 pe-1">
                    <mat-label>{{ field.label || ('ASSORTED.INSERT_VALUE' | translate) }}</mat-label>
                    <input type="text" matInput [formControl]="getFormControl(tabIndex, field.key)" />
                  </mat-form-field>

                  <mat-form-field *ngSwitchCase="'select'" class="w-50 pt-2 pe-1">
                    <mat-label>{{ field.label || ('ASSORTED.SELECT_OPTION' | translate) }}</mat-label>
                    <mat-select [formControl]="getFormControl(tabIndex, field.key)">
                      @for (option of field.options; let i = $index; track option) {
                        <mat-option [value]="option">
                          {{ field.optionLabels ? field.optionLabels[i] : ('NAVBAR.LANGUAGES.' + option | translate) }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field *ngSwitchCase="'textarea'" class="w-100 pt-2 pe-1">
                    <mat-label>{{ field.label || ('ASSORTED.DATA' | translate) }}</mat-label>
                    <textarea matInput cdkTextareaAutosize
                              [formControl]="getFormControl(tabIndex, field.key)"
                              cdkAutosizeMinRows="10"
                              cdkAutosizeMaxRows="10"></textarea>
                  </mat-form-field>

                  <div *ngSwitchCase="'radio'" class="w-100 pt-2 pe-1">
                    @if (field.label) {
                      <div class="radio-group-label">{{ field.label }}</div>
                    }
                    <mat-radio-group [formControl]="getFormControl(tabIndex, field.key)" class="d-flex gap-3">
                      @for (option of field.options; let i = $index; track option) {
                        <mat-radio-button color="primary" [value]="option">
                          {{ field.optionLabels ? field.optionLabels[i] : option }}
                        </mat-radio-button>
                      }
                    </mat-radio-group>
                  </div>
                </ng-container>
                }
              }
            </div>
          </mat-tab>
        }
      </mat-tab-group>
    }
	</mat-dialog-content>

	<mat-dialog-actions [align]="'end'">
		<mat-divider class="w-100 my-2"></mat-divider>
		@if(buttonVisibility('CONFIRM')) {
		<button mat-flat-button color="warn" (click)="buttonAction(true)" [disabled]="data.confirmDisabled || !isFormValid()">
			{{ 'BUTTON.CONFIRM' | translate }}
		</button>

		} @if(buttonVisibility('CANCEL')){
		<button mat-flat-button color="primary" (click)="closeDialog()">
			{{ 'BUTTON.CANCEL' | translate }}
		</button>
		}
	</mat-dialog-actions>
</div>
